import React from "react";

const COMMON = new Set([
  "password","password1","password123","123456","12345678","qwerty","qwerty123",
  "abc123","iloveyou","letmein","monkey","dragon","master","sunshine","princess",
  "welcome","shadow","superman","trustno1","admin","admin123","passw0rd","p@ssword",
  "changeme","secret","test123","ciao","ciao123","italia","amore","prova",
]);

export function passwordStrength(pw) {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[a-zA-Z]/.test(pw) && /[0-9]/.test(pw)) score++;
  if (/[^a-zA-Z0-9]/.test(pw)) score++;
  if (COMMON.has(pw.toLowerCase())) score = Math.min(score, 1);
  return Math.min(score, 4);
}

const LEVELS = [
  { label: "Molto debole", color: "bg-red-500" },
  { label: "Debole",       color: "bg-orange-400" },
  { label: "Discreta",     color: "bg-yellow-400" },
  { label: "Buona",        color: "bg-lime-500" },
  { label: "Ottima",       color: "bg-green-600" },
];

export default function PasswordStrengthBar({ password }) {
  if (!password) return null;
  const level = passwordStrength(password);
  const { label, color } = LEVELS[level];

  return (
    <div className="mt-2 space-y-1">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${
              i <= level ? color : "bg-[#EAE3D9]"
            }`}
          />
        ))}
      </div>
      <p className={`text-[11px] font-medium ${level <= 1 ? "text-red-600" : level <= 2 ? "text-yellow-600" : "text-green-700"}`}>
        {label}
      </p>
    </div>
  );
}
